import {
  PRODUCT_QUANTITY_ADD_FAILURE,
  PRODUCT_QUANTITY_ADD_REQUEST,
  PRODUCT_QUANTITY_ADD_SUCCESS,
  PRODUCT_QUANTITY_DELETE_FAILURE,
  PRODUCT_QUANTITY_DELETE_REQUEST,
  PRODUCT_QUANTITY_DELETE_SUCCESS,
  PRODUCT_QUANTITY_EDIT_FAILURE,
  PRODUCT_QUANTITY_EDIT_REQUEST,
  PRODUCT_QUANTITY_EDIT_SUCCESS,
  PRODUCT_QUANTITY_RESET_STATE,
  PRODUCT_QUANTITY_SEARCH_FAILURE,
  PRODUCT_QUANTITY_SEARCH_REQUEST,
  PRODUCT_QUANTITY_SEARCH_SUCCESS,
  PRODUCT_QUANTITY_VIEW_ALL_FAILURE,
  PRODUCT_QUANTITY_VIEW_ALL_REQUEST,
  PRODUCT_QUANTITY_VIEW_ALL_SUCCESS,
  PRODUCT_QUANTITY_VIEW_FAILURE,
  PRODUCT_QUANTITY_VIEW_REQUEST,
  PRODUCT_QUANTITY_VIEW_SUCCESS,
} from "./ProductQuantityTypes";

// Add Product Quantity Actions
export const productQuantityAddRequest = (credentials) => ({
  type: PRODUCT_QUANTITY_ADD_REQUEST,
  payload: credentials,
});

export const productQuantityAddSuccess = (quantity) => ({
  type: PRODUCT_QUANTITY_ADD_SUCCESS,
  payload: quantity,
});

export const productQuantityAddFailure = (error) => ({
  type: PRODUCT_QUANTITY_ADD_FAILURE,
  payload: error,
});

// Edit Product Quantity Actions
export const productQuantityEditRequest = (quantityId, updatedData) => ({
  type: PRODUCT_QUANTITY_EDIT_REQUEST,
  payload: { quantityId, updatedData },
});

export const productQuantityEditSuccess = (quantity) => ({
  type: PRODUCT_QUANTITY_EDIT_SUCCESS,
  payload: quantity,
});

export const productQuantityEditFailure = (error) => ({
  type: PRODUCT_QUANTITY_EDIT_FAILURE,
  payload: error,
});

// View Product Quantity Actions
export const productQuantityViewRequest = (quantityId) => ({
  type: PRODUCT_QUANTITY_VIEW_REQUEST,
  payload: quantityId,
});

export const productQuantityViewSuccess = (quantity) => ({
  type: PRODUCT_QUANTITY_VIEW_SUCCESS,
  payload: quantity,
});

export const productQuantityViewFailure = (error) => ({
  type: PRODUCT_QUANTITY_VIEW_FAILURE,
  payload: error,
});

// View All Product Quantity Actions
export const productQuantityViewAllRequest = (payload) => ({
  type: PRODUCT_QUANTITY_VIEW_ALL_REQUEST,
  payload,
});

export const productQuantityViewAllSuccess = (quantities) => ({
  type: PRODUCT_QUANTITY_VIEW_ALL_SUCCESS,
  payload: quantities,
});

export const productQuantityViewAllFailure = (error) => ({
  type: PRODUCT_QUANTITY_VIEW_ALL_FAILURE,
  payload: error,
});

// View All Search Product Quantity Actions
export const productQuantitySearchViewAllRequest = () => ({
  type: PRODUCT_QUANTITY_SEARCH_REQUEST,
});

export const productQuantitySearchViewAllSuccess = (quantities) => ({
  type: PRODUCT_QUANTITY_SEARCH_SUCCESS,
  payload: quantities,
});

export const productQuantitySearchViewAllFailure = (error) => ({
  type: PRODUCT_QUANTITY_SEARCH_FAILURE,
  payload: error,
});

// Delete Quantity Actions
export const productQuantityDeleteRequest = (quantityId) => ({
  type: PRODUCT_QUANTITY_DELETE_REQUEST,
  payload: quantityId,
});

export const productQuantityDeleteSuccess = (quantityId) => ({
  type: PRODUCT_QUANTITY_DELETE_SUCCESS,
  payload: quantityId,
});

export const productQuantityDeleteFailure = (error) => ({
  type: PRODUCT_QUANTITY_DELETE_FAILURE,
  payload: error,
});

//Reset Product
export const productQuantityResetState = () => ({
  type: PRODUCT_QUANTITY_RESET_STATE,
});
